var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCpr = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13 0a4 4 0 0 0-4 4v1h2V4a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v1h2V4a4 4 0 0 0-4-4zm3 14a1 1 0 0 0-1 1v3h-3a1 1 0 0 0 0 2h3v3a1 1 0 0 0 2 0v-3h3a1 1 0 0 0 0-2h-3v-3a1 1 0 0 0-1-1"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M3.429 7.167H28.57c1.894 0 3.43 1.567 3.43 3.5V26.5c0 1.933-1.536 3.5-3.43 3.5H3.43C1.535 30 0 28.433 0 26.5V10.667c0-1.933 1.535-3.5 3.429-3.5M8 9.5v3.333H5.714V9.5H3.43c-.632 0-1.143.522-1.143 1.167V26.5c0 .644.511 1.167 1.143 1.167h2.285v-2.5H8v2.5h16v-2.5h2.286v2.5h2.285c.632 0 1.143-.523 1.143-1.167V10.667c0-.645-.511-1.167-1.142-1.167h-2.286v3.333H24V9.5z",
  clipRule: "evenodd"
})));
export default SvgCpr;